import React, { useState } from 'react';
import { _T, C } from '../../../shared/theme';
import { s_PB, s_GC } from '../../../shared/styles';
import { saveGameScore } from '../../../shared/utils';

const SHAPES = ['🔴','🔵','🟢','🟡','🔶','🔷','⭐','🔺'];
const ROUNDS  = 10;

function makePattern() {
  // Pick 2-3 shapes and build a repeating pattern of length 5 or 6
  const len = 2 + Math.floor(Math.random() * 2); // 2 or 3 shape cycle
  const pool = [...SHAPES].sort(() => Math.random() - 0.5).slice(0, len);
  const seq = Array.from({ length: 5 }, (_, i) => pool[i % len]);
  const answer = pool[5 % len];
  // Make 4 choices: correct + 3 wrong
  const wrong = SHAPES.filter(s => s !== answer).sort(() => Math.random() - 0.5).slice(0, 3);
  const choices = [answer, ...wrong].sort(() => Math.random() - 0.5);
  return { seq, answer, choices };
}

function PatternMatchGame({ lang, onBack }) {
  const nl = lang === 'nl';
  const [round, setRound] = useState(0);
  const [score, setScore] = useState(0);
  const [phase, setPhase] = useState('start'); // start | question | result | done
  const [puzzle, setPuzzle] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const nextRound = (r = 0) => {
    setPuzzle(makePattern()); setFeedback(null); setPhase('question');
  };

  const answer = (choice) => {
    if (phase !== 'question') return;
    const isRight = choice === puzzle.answer;
    setFeedback(isRight ? 'correct' : 'wrong');
    setPhase('result');
    if (isRight) setScore(s => s + 1);
    const next = round + 1;
    setTimeout(() => {
      if (next >= ROUNDS) { saveGameScore('patternmatch', Math.round(((score + (isRight ? 1 : 0)) / ROUNDS) * 100)); setPhase('done'); }
      else { setRound(next); nextRound(next); }
    }, 800);
  };

  if (phase === 'done') {
    return (
      <div>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 13, marginBottom: 12 }}>← {nl ? 'Terug' : 'Back'}</button>
        <div style={{ ...s_GC({ padding: 24, textAlign: 'center' }) }}>
          <div style={{ fontSize: 52, marginBottom: 12 }}>🔮</div>
          <div style={{ color: C.white, fontSize: 20, fontWeight: 700, marginBottom: 4 }}>{nl ? 'Klaar!' : 'Done!'}</div>
          <div style={{ color: _T.accent, fontSize: 32, fontWeight: 700 }}>{score}/{ROUNDS}</div>
          <div style={{ color: C.silver, fontSize: 13, marginBottom: 16 }}>{nl ? 'correcte antwoorden' : 'correct answers'}</div>
          <button style={s_PB({ width: '100%' })} onClick={() => { setRound(0); setScore(0); setPhase('start'); }}>{nl ? 'Opnieuw' : 'Play again'}</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 13, marginBottom: 12 }}>← {nl ? 'Terug' : 'Back'}</button>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <span style={{ color: C.silver, fontSize: 12 }}>{nl ? `Vraag ${round + 1}/${ROUNDS}` : `Question ${round + 1}/${ROUNDS}`}</span>
        <span style={{ color: _T.accent, fontSize: 12, fontWeight: 700 }}>{score} ✓</span>
      </div>

      <div style={{ ...s_GC({ padding: 20, textAlign: 'center', marginBottom: 14 }) }}>
        {phase === 'start' && <><div style={{ fontSize: 40 }}>🔮</div><div style={{ color: C.silver, fontSize: 13, marginTop: 8 }}>{nl ? 'Welk symbool ontbreekt in het patroon?' : 'Which symbol completes the pattern?'}</div></>}
        {(phase === 'question' || phase === 'result') && puzzle && (
          <>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', alignItems: 'center', marginBottom: 14 }}>
              {puzzle.seq.map((s, i) => (
                <div key={i} style={{ fontSize: 28, width: 44, height: 44, borderRadius: 10, background: _T.bg4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{s}</div>
              ))}
              <div style={{ fontSize: 28, width: 44, height: 44, borderRadius: 10, background: phase === 'result' ? (feedback === 'correct' ? '#4AC87A33' : '#C0505033') : _T.bg4, border: `2px dashed ${phase === 'result' ? (feedback === 'correct' ? C.teal : C.red) : C.silver}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {phase === 'result' ? puzzle.answer : '?'}
              </div>
            </div>
            {phase === 'result' && <div style={{ color: feedback === 'correct' ? C.teal : C.red, fontWeight: 700, fontSize: 14 }}>{feedback === 'correct' ? (nl ? '✅ Goed!' : '✅ Correct!') : (nl ? '❌ Fout!' : '❌ Wrong!')}</div>}
          </>
        )}
      </div>

      {phase === 'start' && <button style={s_PB({ width: '100%' })} onClick={() => nextRound(0)}>{nl ? 'Start' : 'Start'}</button>}
      {phase === 'question' && puzzle && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {puzzle.choices.map((c, i) => (
            <button key={i} onClick={() => answer(c)}
              style={{ height: 70, borderRadius: 16, border: `1px solid ${_T.cardBorderBot}`, background: _T.bg4, cursor: 'pointer', fontSize: 28 }}>
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default PatternMatchGame;
